import React, { useEffect } from "react";
import { getBackTestGraph } from "src/Requests/deltaHedgeBackTest";
import useRequest from "src/Hooks/useRequest";
import { IBackTestSearchParams } from "src/Interfaces/deltaHedgeBackTest";
import ScatterLineChart from "src/Components/Charts/ScatterLineChart";

interface IProps {
  searchParam: IBackTestSearchParams;
  refreshFlag: boolean;
}

const BackTestChart: React.FC<IProps> = ({ searchParam, refreshFlag }) => {
  const chartRequest = useRequest(
    () => getBackTestGraph(searchParam),
    () => {}
  );

  const isEmpty = React.useMemo(() => {
    if (searchParam.profileId && searchParam.groupId && searchParam.decileNo)
      return false;
    return true;
  }, [searchParam]);

  React.useEffect(() => {
    if (isEmpty) return;
    chartRequest.fetchData();
    const interval = setInterval(() => {
      chartRequest.fetchData();
    }, 30000);
    return () => clearInterval(interval);
  }, [searchParam, isEmpty]);

  useEffect(() => {
    chartRequest.fetchData();
  }, [refreshFlag]);

  return (
    <div className="w-full min-h-[360px]" onClick={(e) => e.stopPropagation()}>
      <ScatterLineChart
        series={chartRequest.response?.series || []}
        titleX={chartRequest.response?.titleX}
        titleY={chartRequest.response?.titleY}
        heightClassName="min-h-[360px] h-[360px]"
      />
    </div>
  );
};

export default BackTestChart;
